module.exports = __webpack_public_path__ + "4b67670a11df647efcb1bf514af65a24.jpg";